import Vuex from 'vuex';
import Vue from 'vue';
import { Auth } from 'aws-amplify';
import router from '@/router';
import { handleError } from '@/utils/hadle-error';

import userApi from '@/api/user';

Vue.use(Vuex);

const user = JSON.parse(localStorage.getItem('currentUser'));

export default new Vuex.Store({
    state: {
        user,
        isLoggedIn: localStorage.getItem('authenticated') || false,
        progressbar: false,
        referrer: null,
        snackbar: {
            text: '',
            subtext: null,
            isOpened: false,
            color: 'success',
            closable: true,
        },
        isCodeSent: false,
        timeDiff: 0,
    },

    getters: {
        currentUserEmail: (s) => s.user.email,
    },

    mutations: {
        snackbar(state, { text, color, subtext, closable }) {
            state.snackbar = {
                isOpened: true,
                subtext: subtext,
                text,
                color,
                closable: !!closable,
            };
        },

        closeSnackbar(state) {
            state.snackbar.isOpened = false;
        },

        codeSent(state, value) {
            state.isCodeSent = value;
        },

        progressbar(state, show) {
            state.progressbar = show;
        },

        setReferrer(state, value) {
            state.referrer = value || 'rebabids';
        },

        setUser(state, user) {
            state.user = user;
            state.isLoggedIn = true;
        },

        setUserEmail(state, email) {
            state.user.email = email;
            localStorage.setItem('currentUser', JSON.stringify(state.user));
        },

        setTimeDiff(state, timeDiff) {
            state.timeDiff = timeDiff;
        },
    },

    actions: {
        async signIn({ commit, dispatch }, { email, password }) {
            try {
                commit('progressbar', true);
                await Auth.signIn(email, password);
                await dispatch('signedIn');
            } catch (e) {
                handleError(commit, e);
            }
        },

        async checkIfUserExists({ commit }, email) {
            try {
                commit('progressbar', true);
                await Auth.confirmSignUp(email, '000000');
                commit('progressbar', false);
            } catch (e) {
                commit('progressbar', false);
                return e.code === 'NotAuthorizedException';
            }
        },

        async fetchUserData({ commit }) {
            commit('progressbar', true);

            const currentUser = await Auth.currentAuthenticatedUser();
            const credentials = await Auth.currentCredentials();
            localStorage.setItem('authenticated', 'true');
            localStorage.setItem('identityId', credentials.identityId);
            localStorage.setItem('currentUser', JSON.stringify(currentUser.attributes));

            commit('setUser', currentUser.attributes);

            commit('progressbar', false);
        },

        async updateUserEmail({ commit }, email) {
            await userApi.updateUserEmail(email);

            commit('setUserEmail', email);

            if (window.opener) {
                await window.opener.postMessage(
                    {
                        action: 'email-updated',
                        data: {
                            email,
                        },
                    },
                    '*',
                );
            }
        },

        async signedIn({ dispatch, commit }) {
            try {
                await dispatch('fetchUserData');

                commit('snackbar', {
                    text: `You have been logged in.${window.opener ? ' The window will be closed in 5 seconds.' : ''}`,
                    color: 'success',
                });

                dispatch('postUserData');
            } catch (e) {
                console.error(e);
                commit('progressbar', false);
            }
        },

        async signUp({ commit, dispatch, state }, { formData, type, businessInfo }) {
            try {
                const { password } = formData;
                commit('progressbar', true);
                const clientMetadata = {
                    password,
                    user: {
                        referrer: state.referrer,
                        type,
                        email: formData.email,
                        firstName: formData.firstName,
                        lastName: formData.lastName,
                        phoneNumber: formData.phoneNumber,
                    },
                };

                if (type === 'pro') {
                    clientMetadata.user.planID = '0';
                    clientMetadata.user.businessInfo = businessInfo;
                }

                const { user } = await Auth.signUp({
                    username: formData.email,
                    password,
                    clientMetadata: {
                        ...clientMetadata,
                        user: JSON.stringify(clientMetadata.user),
                    },
                });
                console.log(user);

                commit('progressbar', false);

                await dispatch('signIn', {
                    email: formData.email,
                    password,
                });
            } catch (e) {
                handleError(commit, e);
            }
        },

        async postUserData() {
            const payload = {};
            Object.keys(localStorage).forEach((k) => {
                payload[k] = localStorage.getItem(k);
            });

            if (window.parent) {
                await window.parent.postMessage(payload, '*');
            }

            if (window.opener) {
                await window.opener.postMessage(payload, '*');

                setTimeout(() => {
                    window.close();
                }, 5000);
            }
        },

        async forgotPassword({ commit }, email) {
            try {
                commit('progressbar', true);

                await Auth.forgotPassword(email);

                commit('snackbar', {
                    text: `We've sent you a code to ${email}. Please use it reset your password.`,
                    subtext: `If you cannot find the email in your inbox, 
                    please check your spam and promotion folders.`,
                    color: 'success',
                    closable: true,
                });

                commit('codeSent', true);

                commit('progressbar', false);
            } catch (e) {
                handleError(commit, e);
            }
        },

        async forgotPasswordSubmit({ commit }, { email, code, password }) {
            try {
                await Auth.forgotPasswordSubmit(email, code, password);

                await router.push('/login?email=' + email);
            } catch (e) {
                handleError(commit, e);
            }
        },
        fetchPersonalInfo() {
            return userApi.getPersonalInfo();
        },
        updatePersonalInfo(ctx, personalInfo) {
            return userApi.updatePersonalInfo(personalInfo);
        },
        fetchUserEmail() {
            return userApi.getUserEmail();
        },
    },
});
